import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import useIsMobile from "../hooks/useIsMobile";
import MobileOrderSummary from "../components/MobileOrderSummary";
import WindowsOrderSummary from "../components/WindowsOrderSummary";
import useFetchCities from "../hooks/useFetchCities";
import useFetchDiscounts from "../hooks/useFetchDiscounts";
const OrderSummary = () => {
  const { cart, sendCartToBackend, clearCart } = useCart();
  const isMobile = useIsMobile();
  const { cities, citiesLoading, citiesError, citiesRefetch } =
    useFetchCities();
  const navigate = useNavigate();

  const [isReady, setIsReady] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const { discounts, loading, error, refetch } = useFetchDiscounts();
  const total =
    cart.reduce((sum, i) => sum + i.price * i.qty, 0);

  function getBestDiscount(discounts, total) {
    let best = null;

    for (const d of discounts) {
      // parse qualifications
      let quals;
      try {
        quals =
          typeof d.qualifications === "string"
            ? JSON.parse(d.qualifications)
            : d.qualifications;
      } catch {
        continue;
      }

      // only check min_order
      const min = typeof quals.min_order === "number" ? quals.min_order : 0;
      if (total < min) continue;

      // keep the discount with the highest value
      if (best === null || d.value > best.value) {
        best = d;
      }
    }

    return best;
  }
  const bestDiscount = getBestDiscount(discounts, total);

  useEffect(() => {
    const totalQty = cart.reduce((sum, item) => sum + item.qty, 0);
    const hasBundle = cart.some((item) => item.baseBundleId !== undefined);
    // console.log("currentStep " + currentStep);
    if (totalQty <= 2 && !hasBundle && currentStep === 1) {
      navigate("/Order", { replace: true });
    } else {
      setIsReady(true); // Safe to render the page
    }
  }, [cart, navigate, currentStep]);
  
  if (!isReady) return null; // Or a loading spinner if you prefer

  return (
    <Box className="Home dc-page" dir="rtl" sx={{ minHeight: "100vh" }}>
      {isMobile ? (
        <MobileOrderSummary
          cart={cart}
          sendCartToBackend={sendCartToBackend}
          clearCart={clearCart}
          addresses={cities}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      ) : (
        <WindowsOrderSummary
          cart={cart}
          sendCartToBackend={sendCartToBackend}
          clearCart={clearCart}
          addresses={cities}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          appliedDiscount={bestDiscount}
        />
      )}
    </Box>
  );
};

export default OrderSummary;
